async function fetchVersion () {
  const res = await fetch(`/version.json?t=${Date.now()}`, {
    cache: 'no-store',
    headers: { 'Cache-Control': 'no-cache' }
  })
  if (!res.ok) throw new Error(`version.json ${res.status}`)
  return res.json()
}

export default {
  async initVersionCheck ({ commit, dispatch, state }) {
    if (process.env.NODE_ENV !== 'production') return
    if (state.pollHandle) return

    try {
      const { hash } = await fetchVersion()
      commit('setCurrentHash', hash)
      commit('setLatestHash', hash)
    } catch (e) {
      // version.json not reachable yet — leave currentHash null and try again on poll
    }

    const handle = setInterval(() => dispatch('checkForUpdate'), state.pollIntervalMs)
    commit('setPollHandle', handle)

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') dispatch('checkForUpdate')
    })
  },

  async checkForUpdate ({ commit, state }) {
    try {
      const { hash } = await fetchVersion()
      if (!state.currentHash) {
        commit('setCurrentHash', hash)
      }
      commit('setLatestHash', hash)
      if (state.currentHash && hash && hash !== state.currentHash) {
        commit('setUpdateAvailable', true)
      }
    } catch (e) {
      // network blip — try again next interval
    }
  },

  reloadApp () {
    window.location.reload()
  }
}
